module.exports = __webpack_public_path__ + "static/media/full_logo.04659b8f.svg";